import { PLANS, PRICING_SUMMARY } from "constants/RouteContants";

export const EXCLUDED_ROUTES = [PLANS, PRICING_SUMMARY];
